import React from 'react';
import styled from '@emotion/styled';
import ProgressBar from 'components/progress_bar';
import Text from 'components/text';
import { Theme } from '@seedlang/constants';
import { isPresent } from '@seedlang/utils';
import { observer } from 'mobx-react';
import { DailyActivityWrapper } from '@seedlang/hoc';

const Wrapper = styled.div`
  margin-top: 10px;
  font-size: 12px;
  line-height: 14px;
`;

const ProgressText = styled.div`
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 3px;
  bottom: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  text-align: center;
  line-height: 14px;
`;

@observer
class StreakRepairProgress extends React.Component {

  render() {
    return (
      <Wrapper>
        <ProgressBar
          current={this.props.user.currentDayXp}
          total={this.props.streakExtendGoal}
          height='20px'
          borderTopRightRadius='5px'
          borderTopLeftRadius='5px'
          borderBottomRightRadius='5px'
          borderBottomLeftRadius='5px'
          currentBackground={this.props.user.streakCanBeExtended ? Theme.orange : Theme.green}
          background='#5b5b5b'
        >
          <ProgressText>{this.props.user.currentDayXp} XP / {this.props.streakExtendGoal} XP</ProgressText>
        </ProgressBar>
        <Text fontSize='12px' lineHeight='14px' margin='5px 0 0 0'>
          {
            this.props.user.streakCanBeExtended && 
              `Add an extra day to your streak by reaching ${this.props.streakExtendGoal}XP today!`
          }
          {
            !this.props.user.streakCanBeExtended && this.props.streakWasExtendedToday && isPresent(this.props.streakExtendGoal) && 
              `Congrats for reaching  ${this.props.streakExtendGoal}XP! We've extended your streak.`
          }
          {
            !this.props.user.streakCanBeExtended && !this.props.streakWasExtendedToday && isPresent(this.props.streakExtendGoal) &&
              `If you break your streak, you'll get a chance to repair it by reaching ${this.props.streakExtendGoal}XP.`
          }
        </Text>
      </Wrapper>
    );
  }
}

export default DailyActivityWrapper(StreakRepairProgress); 